
export class CardXResponse{

    pi_avs_response = null;
    pt_custom_value_1 = null;
    pt_card_type = null;
    pt_order_id = null;
    pi_response_code = null;
    pt_authorization_code = null;
    pt_card_expiration = null;
    pt_payment_name = null;
    pt_billing_email_address = null;
    pt_custom_name_1 = null;
    pt_decline_order_id = null;
    pt_ach_account_type = null;
    pt_gateway_account = null;
    pt_transaction_amount:String;
    pd_display_items = null;
    pb_avs_only = null;
    pt_card_token = null;
    pt_card_number = null;
    pt_currency = null;
    pi_cvv_response = null;
    pi_response_status = null;
    pd_collect_shipping_information = null;
    pt_billing_postal_code = null;
    pt_scheduled_transaction_amount = null;
    pt_scheduled_surcharge_amount = null;
    constructor() {
        this.pi_avs_response = null;
        this.pt_custom_value_1 = 0;
        this.pt_card_type = null;
        this.pt_order_id = null;
        this.pi_response_code = null;
        this.pt_authorization_code = null;
        this.pt_card_expiration = null;
        this.pt_payment_name = null;
        this.pt_billing_email_address = null;
        this.pt_custom_name_1 = null;
        this.pt_decline_order_id = null;
        this.pt_ach_account_type = null;
        this.pt_gateway_account = null;
        this.pt_transaction_amount = null;
        this.pd_display_items = null;
        this.pb_avs_only = null;
        this.pt_card_token = null;
        this.pt_card_number = null;
        this.pt_currency = null;
        this.pi_cvv_response = null;
        this.pi_response_status = null;
        this.pd_collect_shipping_information = null;
        this.pt_billing_postal_code = null;
        this.pt_scheduled_transaction_amount = null;
        this.pt_scheduled_surcharge_amount = null;
    }

}